import { lazy } from 'react';

// Lazy-loaded components
export const Overview = lazy(() => import('@hub/features/overview/overview'));
export const Profile = lazy(() => import('@hub/features/profile/profile'));

export const ContestCategoryPage = lazy(
  () => import('@hub/features/contest-category/contest-category-page'),
);

export const NovaContestPage = lazy(() =>
  import('@hub/features/nova-contest/contest-page/components').then(
    (module) => ({
      default: module.ContestPageWrapper,
    }),
  ),
);

export const NovaContestDashboard = lazy(
  () => import('@hub/features/contest-dashboard'),
);
export const DashboardContainer = lazy(
  () => import('@hub/features/dashboard-templates/dashboard-container'),
);

export const Achievements = lazy(
  () => import('@hub/features/achievements/achievements'),
);
export const Playbook = lazy(() =>
  import('@monorepo/playbook-client').then((module) => ({
    default: module.PlaybookPage,
  })),
);
export const PlaybookDetailPage = lazy(() =>
  import('@monorepo/playbook-client').then((module) => ({
    default: module.PlaybookDetailPage,
  })),
);
export const Welcome = lazy(() => import('../../features/welcome/welcome'));
export const Partners = lazy(() => import('../../features/partners/partners'));
export const Portfolio = lazy(
  () => import('@hub/features/portfolio/portfolio'),
);

export const LiveChat = lazy(() => import('@hub/features/live-chat/live-chat'));

export const Charts = lazy(() =>
  import('@hub/features/trade-talk').then((module) => ({
    default: module.Charts,
  })),
);

export const TradeTalks = lazy(() =>
  import('@hub/features/trade-talk').then((module) => ({
    default: module.TradeTalks,
  })),
);

export const Article = lazy(() =>
  import('@hub/features/trade-talk').then((module) => ({
    default: module.Article,
  })),
);

export const Position = lazy(() => import('@hub/features/position/position'));

export const AffiliationWelcome = lazy(
  () => import('@hub/features/affiliation/welcome/affiliation-welcome'),
);

export const AffiliationDashboard = lazy(
  () => import('@hub/features/affiliation/affiliation-dashboard-wrapper'),
);

export const AffiliateProgramPage = lazy(
  () => import('@hub/features/affiliate-program/affiliate-program-page'),
);

export const PurchasePage = lazy(() =>
  import('../../features/purchase/purchase').then((module) => ({
    default: module.default,
  })),
);

export const AfterPurchase = lazy(() =>
  import('../../features/after-purchase/after-purchase').then((module) => ({
    default: module.default,
  })),
);

export const BlacklistPage = lazy(() =>
  import('@hub/features/blacklist-page').then((module) => ({
    default: module.BlacklistPage,
  })),
);

export const Purchases = lazy(
  () => import('@hub/features/purchases/purchases'),
);
export const PurchasesCoupons = lazy(
  () => import('@hub/features/purchases/coupons/coupons'),
);
export const PurchasesOrders = lazy(
  () => import('@hub/features/purchases/orders/orders'),
);
export const PurchasesWithdrawals = lazy(
  () => import('@hub/features/purchases/withdrawals/withdrawals'),
);
export const PrivacyOptOut = lazy(() =>
  import('@hub/features/privacy-opt-out').then((module) => ({
    default: module.PrivacyOptOutPage,
  })),
);

export const CommunityStats = lazy(
  () => import('@hub/features/community-stats/community-stats-page-wrapper'),
);

export const ReleasePreviewPage = lazy(() =>
  import('@hub/features/release-preview/release-preview-page').then((m) => ({
    default: m.ReleasePreviewPage,
  })),
);
